import React from 'react';
import './App.css';
import { connect } from "react-redux";
import { Cards, Home, StateSelector } from './components';
import { fetchIndiaRecords } from './api/index';
import { dispatchCommonData } from './Actions/index';
import image from './images/covid19ind.png'
class App extends React.Component {
  state = {
    data: {},
  }
  async componentDidMount() {
    const data = await fetchIndiaRecords();

    this.setState({ data });
  }

  handleChangeState = (states) => {
    this.props.dispatchCommonData(states[0]);
  }

  render() {
    const { data } = this.state;

    return (
      <div className="container">
        <img className='image' src={image} alt='coid19'/>
        <Cards data={data} />
        <StateSelector handleChangeState={this.handleChangeState} selectedData={this.props.selectedState} />
        <Home />
      </div>
    );
  }

}

const mapStateToProps = state => {
  return {
    selectedState: state.common.stateData,
  };
};

const mapDispatchToProps = {
  dispatchCommonData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
